(() => {
  const qs = (s, r = document) => r.querySelector(s);
  const qsa = (s, r = document) => [...r.querySelectorAll(s)];

  const setDrawer = (open) => {
    const drawer = qs('[data-cart-drawer]');
    if (!drawer) return;
    drawer.setAttribute('aria-hidden', open ? 'false' : 'true');
    document.body.classList.toggle('drawer-open', open);
  };
  qsa('[data-cart-open]').forEach((b) => b.addEventListener('click', () => setDrawer(true)));
  qsa('[data-cart-close]').forEach((b) => b.addEventListener('click', () => setDrawer(false)));

  const mobileNav = qs('[data-mobile-nav]');
  const setMobile = (open) => {
    if (!mobileNav) return;
    mobileNav.setAttribute('aria-hidden', open ? 'false' : 'true');
    document.body.classList.toggle('mobile-open', open);
  };
  qsa('[data-mobile-menu-open]').forEach((b) => b.addEventListener('click', () => setMobile(true)));
  qsa('[data-mobile-menu-close]').forEach((b) => b.addEventListener('click', () => setMobile(false)));
  qsa('[data-mobile-nav] a').forEach((a) => a.addEventListener('click', () => setMobile(false)));

  const money = (cents) => {
    const currency = window.Shopify?.currency?.active || 'USD';
    try {
      return new Intl.NumberFormat(undefined, { style: 'currency', currency }).format(Number(cents || 0) / 100);
    } catch (_) {
      return `${currency} ${(Number(cents || 0) / 100).toFixed(2)}`;
    }
  };

  const escapeHtml = (value) => String(value ?? '').replace(/[&<>'"]/g, (c) => ({ '&':'&amp;', '<':'&lt;', '>':'&gt;', "'":'&#039;', '"':'&quot;' }[c]));
  const cartShippingHtml = (cart) => {
    const threshold = 7000;
    const remaining = Math.max(0, threshold - Number(cart.total_price || 0));
    const percent = Math.min(100, Math.round((Number(cart.total_price || 0) / threshold) * 100));
    if (remaining > 0) {
      return `<strong>${money(remaining)} away from free shipping</strong><span>Free standard shipping on orders over $70.</span><div class="cart-progress"><span style="width:${percent}%"></span></div>`;
    }
    return `<strong>Free shipping unlocked</strong><span>Your order qualifies for free standard shipping.</span><div class="cart-progress"><span style="width:100%"></span></div>`;
  };

  const renderCartItems = (cart) => {
    if (!cart.items.length) return '<div class="drawer-empty"><strong>Your cart is empty</strong><span>Add a pack to get started.</span></div>';
    return cart.items.map((item) => {
      const properties = Object.entries(item.properties || {}).filter(([, value]) => value !== null && value !== '');
      const propertyHtml = properties.length ? `<div class="drawer-cart-item__properties">${properties.map(([key, value]) => `<span>${escapeHtml(key)}: ${escapeHtml(value)}</span>`).join('')}</div>` : '';
      return `<article class="drawer-cart-item" data-cart-key="${escapeHtml(item.key)}">
        <a class="drawer-cart-item__image" href="${escapeHtml(item.url)}"><img src="${escapeHtml(item.featured_image?.url || '')}" alt="${escapeHtml(item.product_title)}"></a>
        <div class="drawer-cart-item__body">
          <div class="drawer-cart-item__row"><a href="${escapeHtml(item.url)}">${escapeHtml(item.product_title)}</a><strong>${money(item.final_line_price)}</strong></div>
          ${propertyHtml}
          <div class="drawer-cart-item__actions"><div class="drawer-qty"><button type="button" data-cart-qty="minus" data-cart-key="${escapeHtml(item.key)}">−</button><span>${item.quantity}</span><button type="button" data-cart-qty="plus" data-cart-key="${escapeHtml(item.key)}">+</button></div><button type="button" class="drawer-remove" data-cart-remove data-cart-key="${escapeHtml(item.key)}">Remove</button></div>
        </div>
      </article>`;
    }).join('');
  };

  async function refreshCart() {
    const response = await fetch(`${window.Shopify.routes.root}cart.js`, { headers: { Accept: 'application/json' } });
    if (!response.ok) throw new Error('Unable to load cart');
    const cart = await response.json();
    qsa('[data-cart-count]').forEach((node) => { node.textContent = cart.item_count; });
    qsa('[data-cart-total]').forEach((node) => { node.textContent = money(cart.total_price); });
    qsa('[data-cart-shipping]').forEach((node) => { node.innerHTML = cartShippingHtml(cart); });
    const items = qs('[data-cart-items]');
    if (items) items.innerHTML = renderCartItems(cart);
    return cart;
  }

  async function changeCartLine(key, quantity) {
    const response = await fetch(`${window.Shopify.routes.root}cart/change.js`, {
      method: 'POST', headers: {'Content-Type':'application/json','Accept':'application/json'},
      body: JSON.stringify({ id: key, quantity: Math.max(0, Number(quantity) || 0) })
    });
    if (!response.ok) {
      const error = await response.json().catch(() => ({}));
      throw new Error(error.description || 'Unable to update cart');
    }
    return refreshCart();
  }

  qsa('[data-cart-drawer]').forEach((drawer) => {
    drawer.addEventListener('click', async (event) => {
      const control = event.target.closest('[data-cart-qty], [data-cart-remove]');
      if (!control) return;
      const key = control.dataset.cartKey;
      if (!key) return;
      const item = control.closest('[data-cart-key]');
      const current = Number(item?.querySelector('.drawer-qty span')?.textContent || 1);
      const quantity = control.hasAttribute('data-cart-remove') ? 0 : current + (control.dataset.cartQty === 'plus' ? 1 : -1);
      qsa('[data-cart-qty], [data-cart-remove]').forEach((node) => { node.disabled = true; });
      try { await changeCartLine(key, quantity); }
      catch (error) { console.error(error); }
      finally { qsa('[data-cart-qty], [data-cart-remove]').forEach((node) => { node.disabled = false; }); }
    });
  });

  qsa('[data-cart-open]').forEach((button) => button.addEventListener('click', () => { refreshCart().catch(console.error); }));

  qsa('[data-cart-page-qty]').forEach((button) => {
    button.addEventListener('click', () => {
      const input = button.closest('.cart-qty')?.querySelector('input');
      if (!input) return;
      const current = Number(input.value || 1);
      input.value = Math.max(0, current + (button.dataset.cartPageQty === 'plus' ? 1 : -1));
    });
  });

  // Product gallery: render only one safe row of thumbnails at a time.
  // This deliberately uses display:none for thumbnails outside the active page,
  // so extra media can never expand/overlap the purchase column.
  qsa('[data-gallery-pager]').forEach((pager) => {
    const id = pager.dataset.galleryPager;
    const viewport = qs('.mask-gallery__thumbs-viewport', pager);
    const track = qs('.mask-gallery__thumbs', pager);
    const thumbs = qsa(`[data-gallery-thumb="${id}"]`, pager);
    const prev = qs(`[data-gallery-thumb-prev="${id}"]`, pager);
    const next = qs(`[data-gallery-thumb-next="${id}"]`, pager);
    const pageSize = 4;
    let page = 0;

    const pageCount = () => Math.max(1, Math.ceil(thumbs.length / pageSize));

    const measure = () => {
      if (!viewport || !track) return;
      const viewportWidth = Math.max(0, Math.floor(viewport.getBoundingClientRect().width));
      const styles = window.getComputedStyle(track);
      const gap = Math.max(0, parseFloat(styles.columnGap || styles.gap || '0') || 0);
      const size = Math.max(1, Math.floor((viewportWidth - gap * (pageSize - 1)) / pageSize));
      pager.style.setProperty('--gallery-thumb-size', `${size}px`);
      viewport.style.setProperty('--gallery-thumb-size', `${size}px`);
    };

    const render = (requestedPage, instant = false) => {
      page = Math.max(0, Math.min(requestedPage, pageCount() - 1));
      measure();

      const start = page * pageSize;
      const end = start + pageSize;
      thumbs.forEach((thumb, index) => {
        const visible = index >= start && index < end;
        thumb.hidden = !visible;
        thumb.setAttribute('aria-hidden', visible ? 'false' : 'true');
      });

      // Keep the track itself at zero offset. Only the four active items exist
      // in the visual layout, so there is physically nothing to overflow.
      track.style.transition = instant ? 'none' : 'none';
      track.style.transform = 'none';
      track.style.width = '100%';
      track.style.maxWidth = '100%';
      track.style.display = 'grid';
      track.style.gridTemplateColumns = `repeat(${Math.min(pageSize, Math.max(1, Math.min(pageSize, thumbs.length - start)))}, minmax(0, 1fr))`;
      track.style.gap = `${window.innerWidth <= 700 ? 7 : 10}px`;

      const hasPaging = thumbs.length > pageSize;
      pager.classList.toggle('has-pagination', hasPaging);
      if (prev) {
        prev.hidden = !hasPaging;
        prev.disabled = !hasPaging || page === 0;
      }
      if (next) {
        next.hidden = !hasPaging;
        next.disabled = !hasPaging || page >= pageCount() - 1;
      }
    };

    thumbs.forEach((thumb, index) => {
      thumb.addEventListener('click', () => {
        const main = qs(`[data-main-image="${id}"]`);
        if (!main) return;
        main.src = thumb.dataset.imageUrl;
        main.removeAttribute('srcset');
        thumbs.forEach((t) => t.classList.remove('is-active'));
        thumb.classList.add('is-active');
        render(Math.floor(index / pageSize));
      });
    });

    prev?.addEventListener('click', () => render(page - 1));
    next?.addEventListener('click', () => render(page + 1));

    render(0, true);
    const resizeObserver = window.ResizeObserver ? new ResizeObserver(() => render(page, true)) : null;
    if (viewport) resizeObserver?.observe(viewport);
    window.addEventListener('resize', () => render(page, true));
  });

  qsa('[data-gallery-prev], [data-gallery-next]').forEach((button) => {
    button.addEventListener('click', (event) => {
      event.preventDefault();
      event.stopPropagation();
      const id = button.dataset.galleryPrev || button.dataset.galleryNext;
      const thumbs = qsa(`[data-gallery-thumb="${id}"]`);
      const main = qs(`[data-main-image="${id}"]`);
      if (!thumbs.length || !main) return;

      let index = thumbs.findIndex((t) => t.classList.contains('is-active'));
      if (index < 0) index = 0;
      const direction = button.hasAttribute('data-gallery-next') ? 1 : -1;
      index = (index + direction + thumbs.length) % thumbs.length;
      const target = thumbs[index];
      const imageUrl = target.dataset.imageUrl;
      if (!imageUrl) return;

      main.src = imageUrl;
      main.removeAttribute('srcset');
      thumbs.forEach((t) => t.classList.remove('is-active'));
      target.classList.add('is-active');
      // Keep the thumbnail pager on the page containing the selected image.
      const pager = target.closest('[data-gallery-pager]');
      if (pager) {
        const pagerNext = qs(`[data-gallery-thumb-next="${id}"]`, pager);
        if (pagerNext && target.hidden) pagerNext.click();
        const pagerPrev = qs(`[data-gallery-thumb-prev="${id}"]`, pager);
        if (pagerPrev && target.hidden) pagerPrev.click();
      }
    });
  });

  // Pack builder
  qsa('[data-mask-builder]').forEach((builder) => {
    const packs = qsa('[data-pack-card]', builder);
    const extra = qs('[data-extra-mask]', builder);
    const totalNode = qs('[data-builder-total]', builder);
    const productDataNode = builder.closest('.mask-storefront')?.querySelector('[data-product-data]');
    let productData = {};
    try { productData = JSON.parse(productDataNode?.textContent || '{}'); } catch (_) {}

    const getPackData = (pack) => {
      try { return JSON.parse(qs('[data-pack-data]', pack)?.textContent || '{}'); } catch (_) { return {}; }
    };
    const activePack = () => packs.find((p) => qs('[data-pack-radio]', p)?.checked) || packs[0];
    const selectedUpsells = () => qsa('[data-upsell-product]:checked', builder).map((input) => ({
      id: Number(input.dataset.upsellProduct),
      price: Number(input.dataset.priceCents || 0)
    })).filter((item) => item.id);

    const getExtraPrice = () => Number(productData.extraPrice || 0);
    // Character selectors are labels only. Their product prices are intentionally ignored.
    // The real sell price always comes from the main/display product multiplied by pack size.
    const getCharacterItems = (pack) => {
      return qsa('[data-character-select]', pack || {}).map((select, index) => {
        const option = select.options[select.selectedIndex];
        return {
          index: index + 1,
          title: select.value,
          variantId: Number(option?.dataset.variantId || 0),
          image: option?.dataset.image || '',
          available: Boolean(option?.value)
        };
      }).filter((item) => item.title);
    };

    const getPackPrice = (pack) => {
      const data = getPackData(pack || {});
      return Number(data.unitPriceCents || 0) * Number(data.quantity || 1);
    };

    const getPackComparePrice = (pack) => {
      const data = getPackData(pack || {});
      return Number(data.comparePriceCents || 0);
    };

    const updateCharacterImages = (scope) => {
      qsa('[data-character-select]', scope).forEach((select) => {
        const option = select.options[select.selectedIndex];
        const image = option?.dataset.image || '';
        const holder = select.closest('.character-select-wrap')?.querySelector('[data-character-image]');
        if (!holder) return;
        holder.innerHTML = image ? `<img src="${escapeHtml(image)}" alt="">` : '';
      });
    };

    const update = () => {
      const current = activePack();
      packs.forEach((p) => p.classList.toggle('is-selected', p === current));
      const data = getPackData(current || {});
      let price = getPackPrice(current);
      if (extra?.checked) price += getExtraPrice();
      selectedUpsells().forEach((item) => {
        price += Number(item.price || 0);
      });
      if (totalNode) totalNode.textContent = money(price);
      updateCharacterImages(current || builder);
    };

    packs.forEach((pack) => {
      qs('[data-pack-radio]', pack)?.addEventListener('change', update);
      qsa('[data-character-select]', pack).forEach((select) => select.addEventListener('change', update));
    });
    extra?.addEventListener('change', update);
    qsa('[data-upsell-product]', builder).forEach((input) => input.addEventListener('change', update));
    update();

    const addButton = qs('[data-add-pack]', builder);
    addButton?.addEventListener('click', async () => {
      const pack = activePack();
      const data = getPackData(pack || {});
      const characterItems = getCharacterItems(pack);
      const packQuantity = Number(data.quantity || 1);
      const baseVariantId = Number(data.variantId || productData.fallbackVariantId || 0);

      if (!baseVariantId || data.available === false) {
        alert('The main mask product variant is unavailable.');
        return;
      }

      if (characterItems.length !== packQuantity) {
        alert(`Please select a character for every mask in this ${packQuantity}x pack.`);
        return;
      }

      addButton.disabled = true;
      const original = addButton.textContent;

      let addedLineKeys = [];
      try {
        // IMPORTANT: the character collection is only the visual/type selector.
        // Its product price is ignored. Shopify charges the main mask variant price
        // multiplied by the selected pack quantity.
        const properties = { Pack: data.title || `${packQuantity}x Pack` };
        characterItems.forEach((character) => {
          properties[`Mask ${character.index}`] = character.title;
        });

        const items = [{
          id: baseVariantId,
          quantity: packQuantity,
          properties
        }];

        // The extra offer must point to a real discounted Shopify product/variant.
        // That makes the discount real in Shopify checkout rather than cosmetic.
        if (extra?.checked && productData.extraVariantId) {
          items.push({
            id: Number(productData.extraVariantId),
            quantity: 1,
            properties: { 'Offer': 'Extra mask offer' }
          });
        }

        selectedUpsells().forEach((item) => items.push({ id: item.id, quantity: 1 }));

        const response = await fetch(`${window.Shopify.routes.root}cart/add.js`, {
          method: 'POST',
          headers: {'Content-Type':'application/json','Accept':'application/json'},
          body: JSON.stringify({items})
        });

        const addedCart = await response.json().catch(() => ({}));
        if (!response.ok) {
          throw new Error(addedCart.description || 'Add to cart failed');
        }
        addedLineKeys = Array.isArray(addedCart.items)
          ? addedCart.items.map((item) => item.key).filter(Boolean)
          : [];

        // Optional Shopify discount code. This is a real Shopify discount,
        // not a client-side price manipulation. Configure the code in Shopify Admin.
        if (extra?.checked && productData.extraDiscountCode && !productData.extraUsesDiscountedProduct) {
          const code = encodeURIComponent(productData.extraDiscountCode.trim());
          const discountResponse = await fetch(
            `${window.Shopify.routes.root}discount/${code}?redirect=${encodeURIComponent(window.location.pathname)}`,
            { credentials: 'same-origin', redirect: 'follow' }
          );
          if (!discountResponse.ok) {
            throw new Error('The product was added, but the Shopify discount code could not be applied.');
          }

          const discountedCartResponse = await fetch(`${window.Shopify.routes.root}cart.js`, {
            headers: { Accept: 'application/json' },
            credentials: 'same-origin'
          });
          if (discountedCartResponse.ok) {
            const discountedCart = await discountedCartResponse.json();
            if (Number(discountedCart.total_discount || 0) <= 0) {
              throw new Error('The extra-mask voucher is not active. Check the Shopify discount code and its eligibility rules in Admin.');
            }
          }
        }

        await refreshCart();
        setDrawer(true);
      } catch (error) {
        console.error(error);
        if (addedLineKeys.length) {
          try {
            const updates = {};
            addedLineKeys.forEach((key) => { updates[key] = 0; });
            await fetch(`${window.Shopify.routes.root}cart/update.js`, {
              method: 'POST',
              headers: {'Content-Type':'application/json','Accept':'application/json'},
              body: JSON.stringify({ updates })
            });
          } catch (_) {}
        }
        alert(error.message || 'Unable to add this pack.');
        await refreshCart().catch(() => {});
      } finally {
        addButton.disabled = false;
        addButton.textContent = original;
      }
    });

  });

  // Bottom compact pack selector
  qsa('.compact-builder').forEach((section) => {
    const cards = qsa('[data-compact-pack]', section);
    const total = qs('[data-compact-total]', section);
    const fallback = qs('[data-compact-builder-data]', section)?.textContent?.trim();
    const active = () => cards.find((card) => card.classList.contains('is-active')) || cards[0];
    const update = () => {
      cards.forEach((card) => card.classList.toggle('is-active', card === active()));
      const price = Number(active()?.dataset.price || 0);
      if (total) total.textContent = money(price);
    };
    cards.forEach((card) => card.addEventListener('click', () => { cards.forEach((c) => c.classList.remove('is-active')); card.classList.add('is-active'); update(); }));
    update();
    qs('[data-compact-add]', section)?.addEventListener('click', async (event) => {
      const button = event.currentTarget;
      const card = active();
      let variant = Number(card?.dataset.variant || fallback || 0);
      if (!variant) { alert('Choose a product in the theme editor.'); return; }
      button.disabled = true;
      try {
        const response = await fetch(`${window.Shopify.routes.root}cart/add.js`, {
          method:'POST', headers:{'Content-Type':'application/json','Accept':'application/json'},
          body: JSON.stringify({items:[{id:variant, quantity:Number(card.dataset.quantity || 1)}]})
        });
        if (!response.ok) throw new Error('Unable to add this pack.');
        await refreshCart();
        setDrawer(true);
      } catch (error) { alert(error.message); }
      finally { button.disabled = false; }
    });
  });

  // Countdown / motion used by the reference-style storefront.
  qsa('.mask-sale-ticker strong[data-countdown]').forEach((node) => {
    const end = Date.now() + Number(node.dataset.countdown || 0) * 1000;
    const tick = () => {
      const left = Math.max(0, end - Date.now());
      const total = Math.floor(left / 1000);
      const d = Math.floor(total / 86400), h = Math.floor(total % 86400 / 3600), m = Math.floor(total % 3600 / 60), sec = total % 60;
      node.textContent = `${d}d ${String(h).padStart(2,'0')}h ${String(m).padStart(2,'0')}m ${String(sec).padStart(2,'0')}s`;
      if (left > 0) requestAnimationFrame(tick);
    };
    tick();
  });

  // Basic copy/shortcut deterrence. This is not a security boundary: browser menus and developer tools can still be opened outside page JavaScript.
  const isDevToolsShortcut = (event) => {
    const key = String(event.key || '').toLowerCase();
    return key === 'f12' ||
      (event.ctrlKey && event.shiftKey && ['i', 'j', 'c'].includes(key)) ||
      (event.ctrlKey && key === 'u');
  };
  document.addEventListener('contextmenu', (event) => event.preventDefault());
  document.addEventListener('copy', (event) => { event.preventDefault(); });
  document.addEventListener('cut', (event) => { event.preventDefault(); });
  document.addEventListener('keydown', (event) => {
    if (isDevToolsShortcut(event)) {
      event.preventDefault();
      event.stopPropagation();
    }
  }, true);

  // Reveal animations: transform/opacity only, so the page remains accessible without JS.
  const revealNodes = qsa('[data-reveal-section], .adventure-card, .feature-story, .review-card, .product-details__grid');
  if ('IntersectionObserver' in window) {
    const observer = new IntersectionObserver((entries, obs) => {
      entries.forEach((entry) => {
        if (!entry.isIntersecting) return;
        entry.target.classList.add('is-visible');
        obs.unobserve(entry.target);
      });
    }, { rootMargin: '0px 0px -8% 0px', threshold: 0.08 });
    revealNodes.forEach((node) => { node.classList.add('reveal-on-scroll'); observer.observe(node); });
  } else {
    revealNodes.forEach((node) => node.classList.add('is-visible'));
  }

})();
